import {
    Directive,
    Input,
    OnDestroy,
    Renderer2,
    AfterViewChecked,
    ElementRef
} from '@angular/core';
import { NgbPopover } from '@mattlewis92/ng-bootstrap/popover/popover.module';
import { Subscription } from 'rxjs/Subscription';
  
@Directive({
    selector: '[ngbPopover]' // tslint:disable-line
})
export class PopoverNudgerDirective implements OnDestroy, AfterViewChecked {
    @Input() doNotNudge:boolean;
    private shownSubscription: Subscription;
  
    private hiddenSubscription: Subscription;
  
    private popoverWindowElm: ElementRef;
  
    constructor(private renderer: Renderer2, popover: NgbPopover) {
        this.shownSubscription = popover.shown.subscribe(() => {
            this.popoverWindowElm = popover['_windowRef'].location;
        });
        this.hiddenSubscription = popover.hidden.subscribe(() => {
            this.popoverWindowElm = null;
        });
    }
  
    ngAfterViewChecked(): void {
        if (this.doNotNudge) return;
        if (this.popoverWindowElm) {
            var el:HTMLElement = this.popoverWindowElm.nativeElement;
            if (el.parentNode && el.parentNode.nodeName !== "BODY") {
                return;
            }
            var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            var popoverWidth = el.offsetWidth;
            var popoverRightEdge = parseInt(el.style.left) + popoverWidth;
            var arrow = <HTMLElement> el.getElementsByClassName('arrow')[0];
            
            if (parseInt(el.style.left) < 0) {
                // includes 10px padding
                var originalLeft = el.style.left;
                el.style.transform = "translateX(" + (10 - parseInt(el.style.left)) + "px)";
                arrow.style.transform = "translateX(" + (parseInt(el.style.left) - 10) + "px)";
            } else if (popoverRightEdge > windowWidth) {
                // includes 17px for scrollbars and 10px padding
                var overhang = popoverRightEdge - windowWidth;
                el.style.transform = "translateX(" + (-27 - overhang + "px)");
                arrow.style.transform = "translateX(" + (27 + overhang) + "px)";
            }
        }
    }
  
    ngOnDestroy() {
        this.shownSubscription.unsubscribe();
        this.hiddenSubscription.unsubscribe();
    }
  }


// WEBPACK FOOTER //
// ./web/static/services/directives/PopoverNudger.ts